/**
 * Anant Jeevan brand logo — "The True Vine" mark (John 15:5).
 * An eternal loop (anant / infinity) drawn as a living vine — a leaf on the
 * left branch, a cluster of fruit on the right — crowned by the cross rising
 * from the crossing-point: eternal, fruit-bearing life found in Christ alone.
 */
export function LogoMark({ className = "h-10 w-auto" }) {
  return (
    <svg
      viewBox="0 0 50 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* radiant halo behind the cross head */}
      <circle
        cx="25"
        cy="10.5"
        r="8"
        stroke="hsl(var(--gold))"
        strokeOpacity="0.4"
        strokeWidth="1"
      />
      {/* cross — drawn in the current text colour */}
      <path d="M25 2.5V33.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M17.5 10.5H32.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      {/* eternal vine loop — gold */}
      <path
        d="M25 33.5 C21 27.5, 12.5 27.5, 12.5 33.5 C12.5 39.5, 21 39.5, 25 33.5 C29 39.5, 37.5 39.5, 37.5 33.5 C37.5 27.5, 29 27.5, 25 33.5 Z"
        stroke="hsl(var(--gold))"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* vine leaf sprouting from the left branch */}
      <path
        d="M12.5 32.5 C9.5 26.5, 4 25.5, 2.5 29.5 C5.5 33, 10 33.5, 12.5 32.5 Z"
        fill="hsl(var(--forest))"
        fillOpacity="0.95"
      />
      <path d="M12 31.8 C9.5 29.8, 7 28.8, 4.5 29.2" stroke="hsl(var(--background))" strokeWidth="0.7" strokeLinecap="round" strokeOpacity="0.7" />
      {/* fruit cluster hanging from the right branch */}
      <path d="M37.5 34 C39 35.2, 40.2 36.2, 41 37.4" stroke="hsl(var(--gold))" strokeWidth="1.4" strokeLinecap="round" />
      <circle cx="41.6" cy="39.4" r="2.2" fill="#722F37" />
      <circle cx="45.4" cy="37.6" r="2.2" fill="#7E3540" />
      <circle cx="44" cy="41.9" r="2.2" fill="#722F37" />
    </svg>
  );
}

/**
 * Full bilingual lockup. `dark` renders the inverse (for navy surfaces).
 */
export default function Logo({ dark = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-no-translate>
      <LogoMark className={`h-10 w-auto shrink-0 ${dark ? "text-background" : "text-ink"}`} />
      <span className="flex flex-col leading-none">
        <span
          className={`font-serif text-[22px] sm:text-2xl tracking-[0.015em] ${
            dark ? "text-background" : "text-ink"
          }`}
          style={{ fontWeight: 600 }}
        >
          Anant Jeevan
        </span>
        <span
          className={`font-hindi text-[13px] mt-1 ${dark ? "text-gold" : "text-ink-muted"}`}
        >
          अनन्त जीवन <span className={dark ? "text-background/50" : "text-ink-muted/70"}>· Eternal Life in Christ</span>
        </span>
      </span>
    </span>
  );
}
